import axios from 'axios'
import { generateAuthHeaders, extractPathFromUrl } from '../utils/auth'
import { handleApiError, ApiError } from '../utils/errorHandler'

const baseURL = 'https://server.love-study.tech/api'

class HttpRequest {
    constructor(baseURL) {
        this.baseURL = baseURL
    }

    getInsideConfig() {
        const config = {
            baseURL: this.baseURL,
            headers: {}
        }
        return config
    }

    interceptors(instance) {
        // 添加请求拦截器
        instance.interceptors.request.use(function (config) {
            // 获取请求方法和路径
            const method = config.method || 'get';
            const path = extractPathFromUrl(config.url);

            // 获取请求参数
            let requestParams = {};
            if (method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
                requestParams = config.params || {};
            }
            console.log('info11: ', method, path, requestParams)

            // 生成鉴权头部
            const authHeaders = generateAuthHeaders(method, path, requestParams);
            const token = localStorage.getItem('token');

            // 将鉴权头部添加到请求配置中
            config.headers = {
                ...config.headers,
                ...authHeaders,
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            };

            console.log('请求配置:', {
                url: config.url,
                path: path,
                method: method,
                params: requestParams,
                headers: config.headers
            });

            return config;
        }, function (error) {
            // 对请求错误做些什么
            return Promise.reject(error);
        });

        // 添加响应拦截器
        instance.interceptors.response.use(function (response) {
            // 对响应数据做点什么
            return response;
        }, function (error) {
            console.log(error, 'error')
            const errCode = error?.response?.status
            const errMsg = error?.response?.data?.err_msg
            if (errCode) handleApiError(errCode, errMsg)
            return Promise.reject(new ApiError(errCode, errMsg || error.message));
        });
    }
    interceptors_new(instance) {
        // 添加请求拦截器
        instance.interceptors.request.use(function (config) {
            // 获取请求方法和路径
            const method = config.method || 'get';
            const path = extractPathFromUrl(config.url);

            // 获取请求参数
            let requestParams = {};
            if (method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
                requestParams = config.params || {};
            }

            console.log('info11: ', method, path, requestParams)
            // 生成鉴权头部
            const authHeaders = generateAuthHeaders(method, path, requestParams);
            const token = localStorage.getItem('token');

            // 将鉴权头部添加到请求配置中
            config.headers = {
                ...config.headers,
                ...authHeaders,
                ...(token ? { Authorization: `Bearer ${token}` } : {})
            };

            console.log('请求配置:', {
                url: config.url,
                path: path,
                method: method,
                params: requestParams,
                headers: config.headers
            });

            return config;
        }, function (error) {
            // 对请求错误做些什么
            return Promise.reject(error);
        });

        // 添加响应拦截器
        instance.interceptors.response.use(function (response) {
            // 对响应数据做点什么
            if (response.status === 200) {
                const data = response.data
                if (data && data.err_code !== undefined && data.err_code !== 200) {
                    handleApiError(data.err_code, data.err_msg)
                    return Promise.reject(new ApiError(data.err_code, data.err_msg))
                }
                return data
            } else {
                return Promise.reject(new ApiError(response.status, response.statusText));
            }

        }, function (error) {
            console.log(error, 'error')
            const errCode = error?.response?.status
            const errMsg = error?.response?.data?.err_msg
            if (errCode) handleApiError(errCode, errMsg)
            return Promise.reject(new ApiError(errCode, errMsg || error.message));
        });
    }
    request(options) {
        const instance = axios.create({ baseURL: '/api' })
        options = { ...this.getInsideConfig(), ...options }
        this.interceptors(instance)
        return instance(options)
    }
    // 添加统一返回数据拦截处理
    fetch(options) {
        const instance = axios.create({ baseURL: '/api' })
        options = { ...this.getInsideConfig(), ...options }
        this.interceptors_new(instance)
        return instance(options)
    }
}

const httpRequest = new HttpRequest(baseURL)
export default httpRequest